import { obterPedidosAsync, obterPedidosEntradaAsync } from "../../services/pedidoService";

const atualizarPedidos = async ({ commit }) => {
    const pedidos = await obterPedidosAsync();
    commit('atualizarPedidos', pedidos);
}

const atualizarPedido = ({ commit }, pedido) => {
    commit('atualizarPedido', pedido);
}

const updatePedido = ({ commit }, pedido) => {
    commit('updatePedido', pedido);
}

const upsertPedido = ({ commit }, pedido) => {
    commit('upsertPedido', pedido);
}

const atualizarPedidosEntrada = async ({ commit }, idEntradaAtual = null) => {
    const pedidosEntrada = await obterPedidosEntradaAsync(idEntradaAtual);
    commit('atualizarPedidosEntrada', pedidosEntrada);
}

export default {
    atualizarPedidos,
    atualizarPedido,
    atualizarPedidosEntrada,
    updatePedido,
    upsertPedido
}
